var React = require('react');

function ToolAzureml (props) {
    return React.createElement("svg",props,[React.createElement("g",{"className":"fill-foreground","key":0},[React.createElement("rect",{"x":"14.6","y":"5","width":"6.6","height":"9.7","key":0}),React.createElement("polygon",{"points":"14.6,14.7 5.7,24.8 7.2,31 21.2,14.7 ","key":1}),React.createElement("polygon",{"points":"22.8,16.5 30.3,24.7 28.7,31 18.7,21.2 ","key":2})]),React.createElement("polygon",{"className":"fill-background","points":"22.2,24.6 12.7,24.6 7.2,31 28.7,31 ","key":1})]);
}

ToolAzureml.defaultProps = {"version":"1.0","width":"36px","height":"36px","viewBox":"0 0 36 36","xmlSpace":"preserve"};

module.exports = ToolAzureml;

ToolAzureml.default = ToolAzureml;
